module.exports = __webpack_public_path__ + "static/media/face.46eca26f.jpg";